import React from 'react';
import { DotLottieReact } from '@lottiefiles/dotlottie-react';


interface ErrorStateProps {
  message?: string;
  error?: string;
  onRetry?: () => void;
}

const ErrorState: React.FC<ErrorStateProps> = ({ 
  message = 'Something went wrong',
}) => {
  return (
    <div className="flex items-center justify-center min-h-[90vh] bg-[#1a1a1a]"
    
    style={{
        
    }}>
      <div className="text-center max-w-xl px-6">
        {/* Error Icon */}
        {/* <div className="inline-flex items-center justify-center w-20 h-20 rounded-full bg-red-900/30 mb-4">
          <svg 
            className="w-10 h-10 text-red-500" 
            fill="none" 
            stroke="currentColor" 
            viewBox="0 0 24 24"
          >
            <path 
              strokeLinecap="round" 
              strokeLinejoin="round" 
              strokeWidth={2} 
              d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" 
            />
          </svg>
        </div> */}
        <DotLottieReact
            src="https://lottie.host/586b9cae-102d-432a-a072-8ac1806ba76c/Cc8H3XnzxJ.lottie"
            
            autoplay
            />

        <h2 className="text-white text-md italic font-normal mt-[-70px]">Hmm… that didn’t load as expected.</h2>
        
        {/* {error && (
          <p className="text-red-400 text-sm mb-6 bg-red-900/20 rounded-lg p-3 border border-red-800/30">
            {error}
          </p>
        )} */}

     
      </div>
    </div>
  );
};

export default ErrorState;
